// ScrollMagic animations
jQuery(function () {

  let homepageCarouselRevealController,
    slidingDoorsController,
    pinSpacerElements = document.querySelectorAll('[data-scrollmagic-pin-spacer]')

  if (window.innerWidth < 1000) {
    enableOrDisableSlidingDoors(false)
  } else {
    initSlidingDoorsScrollMagic()
  }

  jQuery(window).resize(() => {
    enableOrDisableSlidingDoors(window.innerWidth >= 1000)
  })

  function enableOrDisableSlidingDoors (enabled) {

    if (typeof homepageCarouselRevealController !== 'undefined') {
      homepageCarouselRevealController.destroy(true)
      homepageCarouselRevealController.enabled(false)
    }

    if (typeof slidingDoorsController !== 'undefined') {
      slidingDoorsController.destroy(true)
      slidingDoorsController.enabled(false)
    }

    if (typeof pinSpacerElements !== 'undefined' && pinSpacerElements.length) {
      for (let i = 0; i < pinSpacerElements.length; i++) {
        pinSpacerElements[i].style = null
      }
    }

    if (enabled) {
      initSlidingDoorsScrollMagic()
    }
  }

  function initSlidingDoorsScrollMagic () {

    homepageCarouselRevealController = new ScrollMagic.Controller()
    slidingDoorsController = new ScrollMagic.Controller()

    // Home hero
    const scaleAnimation = new TimelineMax()
      .to('#home-hero-overlay', 1, {
        'max-width': '100%'
      })

    new ScrollMagic.Scene({
      triggerElement: '#home-hero-carousel',
      triggerHook: 0.15,
      duration: 600,
      offset: 100
    })
      .setTween(scaleAnimation)
      .addTo(homepageCarouselRevealController)

    // Sliding doors
    const slidingDoorsElements = document.getElementsByClassName('sliding-doors-container')

    for (let i = 0; i < slidingDoorsElements.length; i++) {

      const element = slidingDoorsElements[i].querySelector('.sliding-doors'),
        offset = typeof element.dataset.offset !== undefined ? parseInt(element.dataset.offset) : 0

      const wipeAnimation = new TimelineMax()
        .to(element, 1, {
          'max-width': '102%'
        })

      let slidingDoors = new ScrollMagic.Scene({
        triggerElement: slidingDoorsElements[i],
        triggerHook: 'onCenter',
        duration: '50%',
        offset: offset
      })
        //.setPin(slidingDoorsElements[i])
        .setTween(wipeAnimation)
        .addTo(slidingDoorsController)
    }

  }

  // Reveal
  const revealController = new ScrollMagic.Controller(),
    revealElements = document.getElementsByClassName('reveal')
  for (let i = 0; i < revealElements.length; i++) { // create a scene for each element
    new ScrollMagic.Scene({
      triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
      offset: 100,												 // start a little later
      triggerHook: 0.9,
    })
      .setClassToggle(revealElements[i], 'revealed') // add class toggle
      .addTo(revealController)
  }
})



// WEBPACK FOOTER //
// ./scripts/lib/scroll-magic.js